import React, { Component, useEffect, useState } from 'react'
import { CircularProgressbar, buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import { Grid, GridColumn, Popup, Icon } from 'semantic-ui-react';
import { getFillRate, getMarketsFillRate, getCategoriesFillRate } from 'services/Accounts';
import './FillRatePanel.less'

const FillRatePanel = ({ handleFillRateSelectedFilters, handleFillRateMapModalOpen, handleFillRateMapDataToShow, fillRateFilterDataToShow, lastDays, refreshData }) => {

    const [fillRateData, setFillRateDataState] = useState(undefined);
    const [fillRatePanelHeadingState, setFillRatePanelHeadingState] = useState("");
    const [fillRateFilterDataToShowState, setFillRateFilterDataToShowState] = useState("");
    const [firstLevelFillRateSelectedObject, setFirstLevelFillRateSelectedObject] = useState("");

    useEffect(() => {
        if (fillRateFilterDataToShow) {
            getFillRateFiltersData(fillRateFilterDataToShow);
        }
    }, [fillRateFilterDataToShow]);


    useEffect(() => {
        if (lastDays && fillRateFilterDataToShowState) {
            getFillRateFiltersData(fillRateFilterDataToShowState, firstLevelFillRateSelectedObject);
        }
    }, [lastDays]);

    useEffect(() => {
        if (refreshData && fillRateFilterDataToShowState) {
            getFillRateFiltersData(fillRateFilterDataToShowState, firstLevelFillRateSelectedObject);
        }
    }, [refreshData]);


    const getFillRateFiltersData = async (fillRateFilterDataToShow, fillRateObject = undefined) => {
        let response = undefined;
        if (fillRateFilterDataToShow == "market") {
            // only market higher level data will show
            response = await getMarketsFillRate(undefined, lastDays);
            setFillRatePanelHeadingState("Markets")
        } else if (fillRateFilterDataToShow == "category") {
            // only category higher level data will show
            response = await getCategoriesFillRate(undefined, lastDays);
            setFillRatePanelHeadingState("Categories")
        } else if (fillRateFilterDataToShow == "categoriesUnderMarket") {
            // will display all categories data under selected market
            response = await getCategoriesFillRate(fillRateObject.id, lastDays);
            setFillRatePanelHeadingState("Fill Rate For " + fillRateObject.name)
        } else if (fillRateFilterDataToShow == "marketsUnderCategory") {
            // will display all markets data under selected category
            response = await getMarketsFillRate(fillRateObject.id, lastDays);
            setFillRatePanelHeadingState("Fill Rate For " + fillRateObject.name)
        }

        if (response && response.resStatus == 200) {
            setFillRateDataState(response.data);
        } else {
            setFillRateDataState(undefined);
        }
        setFillRateFilterDataToShowState(fillRateFilterDataToShow);
    }

    const onFillRateContainerClick = (fillRateObject) => {
        if (fillRateFilterDataToShowState == "market") {
            getFillRateFiltersData("categoriesUnderMarket", fillRateObject)
            handleFillRateSelectedFilters("market", fillRateObject)
            //fillRateFilterDataToShowHandler("categoriesUnderMarket")
        } else if (fillRateFilterDataToShowState == "category") {
            getFillRateFiltersData("marketsUnderCategory", fillRateObject)
            handleFillRateSelectedFilters("category", fillRateObject)
            //fillRateFilterDataToShowHandler("marketsUnderCategory")
        }
        setFirstLevelFillRateSelectedObject(fillRateObject);
    }

    const onBackArrowClick = () => {
        if (fillRateFilterDataToShowState == "categoriesUnderMarket") {
            getFillRateFiltersData("market")
        } else if (fillRateFilterDataToShowState == "marketsUnderCategory") {
            getFillRateFiltersData("category")
        }
    }

    const isOnFirstLevel = () => {
        if (fillRateFilterDataToShowState == "market" || fillRateFilterDataToShowState == "category") {
            return true;
        }
        else {
            return false;
        }
    }

    const handleMapIconClick = async (e, fillRateObject) => {
        e.stopPropagation();
        handleFillRateMapModalOpen(true);
        if (fillRateFilterDataToShowState == "market" || fillRateFilterDataToShowState == "category") {
            handleFillRateSelectedFilters(fillRateFilterDataToShowState, fillRateObject)
        }
        else if (fillRateFilterDataToShowState == "categoriesUnderMarket") {
            handleFillRateSelectedFilters("category", fillRateObject)
        }
        else if (fillRateFilterDataToShowState == "marketsUnderCategory") {
            handleFillRateSelectedFilters("market", fillRateObject)
        }
        handleFillRateMapDataToShow(fillRateFilterDataToShowState)
    }

    return (
        <div className={"Fill-Rate-panel"}>
            {
                fillRateData &&
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Grid.Row className={`fill-rate-panel-heading`}>
                                <Grid.Column width={8}>
                                    {
                                        isOnFirstLevel() ? "" :
                                            <i onClick={() => { onBackArrowClick() }} class="arrow circle left icon back_arrow"></i>
                                    }
                                    {fillRatePanelHeadingState}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid.Column>
                        {
                            fillRateData.map((fillRates, fillRatesIndex) => {
                                return (
                                    <Grid.Column width={4}>
                                        <div className={`fill-rate-container ${isOnFirstLevel() ? "" : "no-selection"}`} onClick={isOnFirstLevel() ? () => { onFillRateContainerClick(fillRates) } : () => { }} >
                                            <Grid.Row className={"heading-row"}>
                                                {/* <Grid.Column textAlign={"right"} width={2} >
                                                    <Popup position={"bottom center"} content='Map' trigger={<Icon
                                                        onClick={(e) => { handleMapIconClick(e, fillRates) }}
                                                        size="large"
                                                        circular
                                                        name='map'
                                                    />} />
                                                </Grid.Column> */}
                                               
                                            </Grid.Row>
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <CircularProgressbarWithChildren
                                                        value={fillRates ? fillRates.fill_rate : 0}
                                                        // text={`${fillRateData ? parseFloat(fillRateData.fill_rate).toFixed(2) : 0}%`}
                                                        styles={buildStyles({
                                                            // Rotation of path and trail, in number of turns (0-1)
                                                            rotation: 0.25,

                                                            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                                            strokeLinecap: 'butt',

                                                            // Text size
                                                            textSize: '16px',

                                                            // How long animation takes to go from one percentage to another, in seconds
                                                            pathTransitionDuration: 0.5,

                                                            // Can specify path transition in more detail, or remove it entirely
                                                            // pathTransition: 'none',

                                                            // Colors
                                                            pathColor: `rgba(${Math.floor(Math.random() * 257)}, ${Math.floor(Math.random() * 257)}, ${Math.floor(Math.random() * 257)}, ${(fillRates ? fillRates.fill_rate : 0) / 100})`,
                                                            // pathColor: `rgba(${Math.floor(Math.random() * 257)}, ${Math.floor(Math.random() * 257)}, ${Math.floor(Math.random() * 257)}, ${(fillRates ? fillRates.fill_rate : 0) / 100})`,
                                                            textColor: '#f88',
                                                            trailColor: '#d6d6d6',
                                                            backgroundColor: '#3e98c7',
                                                        })}>
                                                        {/* Put any JSX content in here that you'd like. It'll be vertically and horizonally centered. */}
                                                        {/* //<img style={{ width: 40, marginTop: -5 }} src="https://i.imgur.com/b9NyUGm.png" alt="doge" /> */}
                                                        <div className={"progresss-bar-text-container"}>
                                                            <div>
                                                                <strong>{fillRates ? fillRates.name : "N/A"}</strong>
                                                            </div>
                                                            <div>
                                                                <strong>{fillRates ? parseFloat(fillRates.fill_rate).toFixed(2) : 0}%</strong>
                                                            </div>
                                                            <div>
                                                                {"Total Requests : " + (fillRates?.total_request ? fillRates.total_request : "0")}
                                                            </div>
                                                            <div>
                                                                {"Total Accepted : " + (fillRates?.total_accepted ? fillRates.total_accepted : "0")}
                                                            </div>
                                                        </div>
                                                    </CircularProgressbarWithChildren>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </div>
                                    </Grid.Column>
                                )
                            })
                        }
                    </Grid.Row>
                </Grid>
            }
        </div>
    )
}

export default FillRatePanel